import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Media } from '../../theme/Media';
import { useTableContext } from './context';
const Wrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  @media ${({ isCollapsedNav }) => (isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    margin: ${({ sup }) => (sup ? '0 0 -10px 0' : '10px 0 0 0')};
  }
`;
const Numbers = styled.span `
  color: ${({ theme }) => theme.colors.grey70_1};
`;
const Footer = ({ total, current, page, limit, sup, dataTestId }) => {
    const { isCollapsedNav } = useTableContext();
    return (_jsx(Wrapper, { sup: sup, isCollapsedNav: isCollapsedNav, children: _jsx(Numbers, { "data-testid": dataTestId, children: page && limit ? `${(page - 1) * limit + 1} - ${(page - 1) * limit + current} / ${total}` : `1 - ${current} / ${total}` }) }));
};
export default React.memo(Footer);
